import { FETCH_ROOT_PAGE } from "../actions/rootPageActions";

const initState = {};

const rootPageReducer = (state = initState, action) => {
    if (action.type === FETCH_ROOT_PAGE) {
        // Replace, not merge: on a site switch the previous root page's navigation/footer/
        // brand must not survive into a site that does not define them.
        return {
            ...(action.payload || {}),
        };
    }

    return state;
};

export default rootPageReducer;
